/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_TodayInputs */

const en_us2_plan_tab_today = /** @type {(inputs: Plan_Tab_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`today`)
};

const pt_br2_plan_tab_today = /** @type {(inputs: Plan_Tab_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hoje`)
};

const es_419_plan_tab_today = /** @type {(inputs: Plan_Tab_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hoy`)
};

const pt_pt2_plan_tab_today = /** @type {(inputs: Plan_Tab_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hoje`)
};

const fr_fr2_plan_tab_today = /** @type {(inputs: Plan_Tab_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aujourd'hui`)
};

const de_de2_plan_tab_today = /** @type {(inputs: Plan_Tab_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`heute`)
};

const it_it2_plan_tab_today = /** @type {(inputs: Plan_Tab_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oggi`)
};

/**
* | output |
* | --- |
* | "today" |
*
* @param {Plan_Tab_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_tab_today = /** @type {((inputs?: Plan_Tab_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_tab_today(inputs)
	if (locale === "es-419") return es_419_plan_tab_today(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_tab_today(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_tab_today(inputs)
	if (locale === "de-DE") return de_de2_plan_tab_today(inputs)
	if (locale === "it-IT") return it_it2_plan_tab_today(inputs)
	return en_us2_plan_tab_today(inputs)
});
export { plan_tab_today as "plan.tab_today" }